/*!
This file is part of CycloneDX JavaScript Library.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

SPDX-License-Identifier: Apache-2.0
Copyright (c) OWASP Foundation. All Rights Reserved.
*/

import type { Comparable } from '../../_helpers/sortable'
import { SortableComparables } from '../../_helpers/sortable'

export interface OptionalAdvisoryProperties {
  title?: Advisory['title']
}

export class Advisory implements Comparable<Advisory> {
  title?: string
  url: string | URL

  constructor (url: string | URL, op: OptionalAdvisoryProperties = {}) {
    this.url = url
    this.title = op.title
  }

  compare (other: Advisory): number {
    /* eslint-disable @typescript-eslint/strict-boolean-expressions -- run compares in weighted order */
    return this.url.toString().localeCompare(other.url.toString()) ||
      (this.title ?? '').localeCompare(other.title ?? '')
    /* eslint-enable  @typescript-eslint/strict-boolean-expressions */
  }
}

export class AdvisoryRepository extends SortableComparables<Advisory> {}
